import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SystemSection from './components/SystemSection';
import ComparisonSection from './components/ComparisonSection';
import AthleteSection from './components/AthleteSection';
import EarlyAccessSection from './components/EarlyAccessSection';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSignup = () => {
    const signupSection = document.getElementById('early-access');
    if (signupSection) {
      signupSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-black border-b border-[#00FF88]/20' : 'bg-black/80'
        }`}
      >
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/c552d6b895eeb1ca6a26a787763818ee/5319e48af1dac71fd7a1481fc0b376b7.png" 
              alt="THRESH" 
              className="h-10 w-auto"
            />
          </div>
          <div className="flex items-center gap-8">
            <Link
              to="/calculator"
              className="whitespace-nowrap text-sm font-semibold text-white/60 hover:text-[#00FF88] transition-colors cursor-pointer tracking-wide"
            >
              Fueling Calculator
            </Link>
            <button
              onClick={scrollToSignup}
              className="whitespace-nowrap text-[#00FF88] font-semibold text-sm tracking-wide hover:text-white transition-colors cursor-pointer"
            >
              Join Early Access
            </button>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <HeroSection onCtaClick={scrollToSignup} />
      <SystemSection />
      <ComparisonSection />
      <ProblemSection />
      <AthleteSection />
      <EarlyAccessSection />
      <Footer />
    </div>
  );
}